export const netSuiteIdRules = {
    maxLength: 32,
    pattern: /^([\d\w]+)(?:-([\d\w]+))?$/,
};

export const validateNetSuiteId = (netSuiteId: string) => {
    if (netSuiteId.length > netSuiteIdRules.maxLength) {
        return `NetSuite ID cannot be greater than ${netSuiteIdRules.maxLength} characters`;
    }
    if (!netSuiteIdRules.pattern.test(netSuiteId)) {
        return 'Provided NetSuite ID does not match pattern';
    }
    return undefined;
};
